var _ellipse, _ellipse2, _g, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _line, _ellipse7, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotPremiumAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "bg",
    cx: 20,
    cy: 22.0008,
    rx: 20,
    ry: 19.8553,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2678_10520",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 40,
    height: 41
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 22.1449,
    rx: 20,
    ry: 19.8553,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2678_10520)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 48.5465,
    rx: 15.0725,
    ry: 17.4813,
    fill: "#4BC3B5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.34814,
    y: 18.4038,
    width: 31.3043,
    height: 8.05723,
    rx: 1.23457,
    fill: "#4BC3B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.65259,
    y: 16.821,
    width: 28.8406,
    height: 11.3665,
    rx: 1.23457,
    fill: "#48BAAD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.24683,
    y: 15.958,
    width: 25.0725,
    height: 12.9491,
    rx: 1.23457,
    fill: "#4BC3B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6814 15.8544C7.6814 14.451 8.66737 13.2341 10.0469 12.9764C17.5099 11.5824 22.3635 11.5801 29.6763 12.9697C31.0503 13.2307 32.0292 14.4452 32.0292 15.8437V29.2299C32.0292 30.6361 31.041 31.8429 29.6499 32.0481C27.4118 32.3784 23.8195 32.7917 19.8553 32.7917C15.8911 32.7917 12.2988 32.3784 10.0608 32.0481C8.66962 31.8429 7.6814 30.6361 7.6814 29.2299V15.8544Z",
    fill: "#48BAAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71045 18.2539C9.71045 16.822 10.7355 15.5881 12.1498 15.3648C18.0629 14.4312 22.0655 14.4292 27.8615 15.3587C29.2711 15.5847 30.2902 16.8167 30.2902 18.2443V26.7248C30.2902 28.1546 29.2687 29.3749 27.8499 29.552C25.9454 29.7898 23.1081 30.0582 20.0003 30.0582C16.8925 30.0582 14.0552 29.7898 12.1507 29.552C10.7319 29.3749 9.71045 28.1546 9.71045 26.7248V18.2539Z",
    fill: "#4BC3B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1453 18.5751C10.1453 17.1411 11.1734 15.9056 12.5905 15.6862C18.1573 14.8244 21.9637 14.8224 27.421 15.6802C28.8334 15.9023 29.8554 17.1359 29.8554 18.5656V26.4027C29.8554 27.8251 28.845 29.041 27.4342 29.2218C25.6113 29.4554 22.9314 29.714 20.0003 29.714C17.0693 29.714 14.3894 29.4554 12.5665 29.2218C11.1557 29.041 10.1453 27.8251 10.1453 26.4027V18.5751Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.551 25.0225H21.4496V25.0225C21.4496 25.8171 20.7949 26.4613 20.0003 26.4613V26.4613C19.2057 26.4613 18.551 25.8171 18.551 25.0225V25.0225Z",
    fill: "#373838"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.7685,
    cy: 22.4324,
    rx: 1.30435,
    ry: 1.29491,
    fill: "#373838"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.4063,
    cy: 22.6483,
    rx: 0.362319,
    ry: 0.359698,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.7973,
    cy: 22.4324,
    rx: 1.30435,
    ry: 1.29491,
    fill: "#373838"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.4351,
    cy: 22.6483,
    rx: 0.362319,
    ry: 0.359698,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 2.28955,
    x2: 6.5,
    y2: 20.1896,
    stroke: "#4BC3B5"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 1.49167,
    rx: 1.5,
    ry: 1.49167,
    fill: "#4BC3B5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.6543,
    y: 20.1467,
    width: 24.4444,
    height: 0.982169,
    fill: "#373838"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9751,
    y: 22.1111,
    width: 8.14815,
    height: 0.982169,
    fill: "#373838"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.4565,
    y: 22.1111,
    width: 0.987654,
    height: 0.982169,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9875,
    y: 21.1289,
    width: 10.1235,
    height: 0.982169,
    fill: "#373838"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22.9626,
    y: 23.0933,
    width: 6.17284,
    height: 0.982169,
    fill: "#373838"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 23.9504,
    y: 24.0754,
    width: 4.19753,
    height: 0.982169,
    fill: "#373838"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4441,
    y: 23.0933,
    width: 0.987654,
    height: 0.982169,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4688,
    y: 21.1289,
    width: 0.987654,
    height: 0.982169,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 9.62964,
    y: 22.1111,
    width: 8.14815,
    height: 0.982169,
    fill: "#373838"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1111,
    y: 22.1111,
    width: 0.987654,
    height: 0.982169,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 8.64209,
    y: 21.1289,
    width: 10.1235,
    height: 0.982169,
    fill: "#373838"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6172,
    y: 23.0933,
    width: 6.17284,
    height: 0.982169,
    fill: "#373838"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 11.605,
    y: 24.0754,
    width: 4.19753,
    height: 0.982169,
    fill: "#373838"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0989,
    y: 23.0933,
    width: 0.987654,
    height: 0.982169,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1235,
    y: 21.1289,
    width: 0.987654,
    height: 0.982169,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotPremiumAvatar);
export default __webpack_public_path__ + "static/media/robotPremiumAvatar.deda688253760b28cb3d19861a43d0a4.svg";
export { ForwardRef as ReactComponent };